unit Web.Uri.Utils;

interface

/// <summary>
///  Detect local/dev URLs (Sentry and diagnostics filtering).
/// </summary>
function IsLocalHostUri(const AValue: string): Boolean;

implementation

uses
  System.SysUtils;

function IsLocalHostUri(const AValue: string): Boolean;
var
  sValue: string;

begin
  sValue := LowerCase(Trim(AValue));

  Result := (Pos('127.0.0.1', sValue) > 0)
    or (Pos('localhost', sValue) > 0)
    or (Pos('://[::1]', sValue) > 0);

end;

end.
